import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NbAuthComponent, NbResetPasswordComponent } from '@nebular/auth';
import { AuthGuard } from '@app-guards/auth/auth.guard';
import { LoginComponent } from '@app-core/auth/login/login.component';
import { ResetPasswordComponent } from '@app-core/auth/reset-password/reset-password.component';
import { RegisterComponent } from '@app-core/auth/register/register.component';
import { VerifycodeComponent } from '@app-core/auth/verifycode/verifycode.component';
import { RequestPasswordComponent } from '@app-core/auth/request-password/request-password.component';
import { LogoutComponent } from '@app-core/auth//logout/logout.component';
const routes: Routes = [
	{
		path: 'pages',
		loadChildren: () => import('app/pages/pages.module').then(m => m.PagesModule),
		canActivate: [AuthGuard],
	},
	{
		path: 'login',
		component: LoginComponent,
		canActivate: [AuthGuard],
        data: { blockAuthenticated: true }
	},
	{
		path: 'request-password',
		component: RequestPasswordComponent,
	},
	{
		path: 'recover-password',
		component: VerifycodeComponent,
	},
	{
		path: 'auth',
		component: NbAuthComponent,
		children: [
			{
				path: 'register',
				component: RegisterComponent,
			},
			{
				path: 'logout',
				component: LogoutComponent,
			},
			{
				path: 'reset-password',
				component: ResetPasswordComponent,
				canActivate: [AuthGuard],
			},
		],
	},
	{ path: '', redirectTo: 'pages', pathMatch: 'full' },
	{ path: '**', redirectTo: 'pages' },
];
const config: ExtraOptions = {
    useHash: true
};
@NgModule({
	imports: [RouterModule.forRoot(routes, config)],
	exports: [RouterModule],
})
export class AppRoutingModule {
}
